<template>
  <div class="login-page">
    <Header />
    <div class="login-form">
      <Card>
        <div class="mb-3 text-center">
          <h2 class="font-size-20 font-weight-700 text-title-color">Login to Pension Keeper</h2>
        </div>
        <VForm v-model="formValid" @submit.prevent>
          <VRow>
            <VCol cols="12">
              <VTextField
                label="Application No"
                prepend-inner-icon="mdi-account-box-outline"
                variant="outlined"
                color="primary"
                name="applicationNumber"
                :rules="formRules.applicationNumber"
                v-model="form.applicationNumber"
                placeholder="Enter Application No"
                :disabled="isLoading"
                type="text"
              />
            </VCol>
            <VCol cols="12">
              <VTextField
                label="Password"
                prepend-inner-icon="mdi-lock-outline"
                variant="outlined"
                color="primary"
                :rules="formRules.password"
                v-model="form.password"
                placeholder="Enter password"
                @click:append-inner="visiblePassword = !visiblePassword"
                :append-inner-icon="visiblePassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="visiblePassword ? 'text' : 'password'"
                :disabled="isLoading"
              />
            </VCol>
            <VCol cols="12">
              <div class="d-flex align-center justify-end w-100">
                <router-link :to="{ name: 'Forgot Password' }"> Forgot Your Password? </router-link>
              </div>
            </VCol>
            <VCol cols="12">
              <VBtn :loading="isLoading" type="submit" color="primary" block flat @click="handleLogin()">Log in</VBtn>
            </VCol>
          </VRow>
        </VForm>
      </Card>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
// Service
import userService from '@/services/user-service/user.service';
// Components
import Card from '@/components/common/Card/Card.vue';
import Header from '@/components/common/Header/Header.vue';
//Text
import { errorLoginText } from '@/text/snackbarsText';
export default {
  name: 'LoginPage',
  components: {
    Header,
    Card
  },
  data() {
    return {
      visiblePassword: false,
      formRules: {
        applicationNumber: [(v) => !!v || 'Application Number required'],
        password: [(v) => !!v || 'Password required']
      },
      form: {
        applicationNumber: '',
        password: ''
      },
      isLoading: false,
      formValid: false
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar']),
    ...mapActions('user', ['logInUser']),
    async handleLogin() {
      if (this.formValid === true) {
        this.isLoading = true;
        try {
          const { application } = await userService.loginUser(this.form);
          if (application?.id) {
            this.logInUser(application);
            this.$router.push({ name: 'Overview' });
            this.resetForm();
          } else {
            this.showSnackbar({ text: 'Oops, Something Went Wrong', color: 'red' });
          }
        } catch (err) {
          console.error(err);
          this.showSnackbar({ text: errorLoginText, color: 'red' });
        } finally {
          this.isLoading = false;
        }
      }
    },
    resetForm() {
      this.form = {
        applicationNumber: '',
        password: ''
      };
    }
  }
};
</script>
